import React from 'react';

const DefaultLink = ({ children, ...props }) => (
  <a href="/" target="_blank" rel="noreferrer noopener" {...props}>
    {children}
  </a>
);

export default DefaultLink;
